import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { spacing4x, spacing2x } from '../../styles/spacing.js';
import { useAccordionContext } from '../AccordionContext/AccordionContext.js';
import { useAccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var Panel = styled.div.withConfig({
  displayName: "AccordionPanel__Panel",
  componentId: "sc-1x2eley-0"
})(["&&{background:", ";max-height:", ";overflow-y:auto;padding:", ";padding-block-start:", ";width:100%;cursor:default;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.white;
}, function (_ref2) {
  var $variant = _ref2.$variant;
  return $variant === "embedded" ? void 0 : "320px";
}, spacing4x + " " + spacing2x, spacing2x);
var AccordionPanel = /*#__PURE__*/React.forwardRef(function AccordionPanel2(props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var _useAccordionItemCont = useAccordionItemContext(),
    headerId = _useAccordionItemCont.headerId,
    open = _useAccordionItemCont.open,
    panelId = _useAccordionItemCont.panelId;
  var _useAccordionContext = useAccordionContext(),
    nonDestructive = _useAccordionContext.nonDestructive,
    $variant = _useAccordionContext.variant;
  var panelProps = _objectSpread({
    $variant: $variant,
    "aria-labelledby": headerId,
    children: children,
    id: panelId,
    ref: ref,
    role: "region"
  }, rest);
  if (nonDestructive) return /*#__PURE__*/jsx(Panel, _objectSpread(_objectSpread({}, panelProps), {}, {
    hidden: !open
  }));
  return open ? /*#__PURE__*/jsx(Panel, _objectSpread({}, panelProps)) : null;
});
AccordionPanel.displayName = "AccordionPanel";

export { AccordionPanel };
